import { PlayerOnPitchStats } from '@/common/constants';
import { StatsShotsChartOptions, TeamFilterOptionValues } from '../constants';
import MainMenuOptionValues from '../constants/MainMenuOptionValues';

export const TrackingTabs = {
  Stats: MainMenuOptionValues.STATS,
  Table: MainMenuOptionValues.TABLE,
  Players: MainMenuOptionValues.PLAYERS,
  Lineup: MainMenuOptionValues.LINEUP,
} as const;

export const TrackingFilters = {
  Goals: 'goals',
  Assists: 'assists',
  Shots: 'shots',
  Cards: 'cards',
  Injured: 'injured',
  GoalAndAssist: 'goal_and_assist',
  All: 'all',
  HomeTeam: 'home_team',
  AwayTeam: 'away_team',
  OnOffGame: 'on_off_game',
  ConcededGame: 'conceded_game',
} as const;

export const TrackingElements = {
  Retry: 'retry',
} as const;

export const TrackingEvents = {
  MainTabClick: 'mainTabClick',
  FilterClick: 'filterClick',
  CtaClick: 'ctaClick',
} as const;

export const TrackingSources = {
  Prematch: 'prematch-stats',
  Mini: 'mini-widgets',
} as const;

/** UI state values that differ from KSP analytics names. */
export const UI_TO_ANALYTICS_NAME_MAP: Record<string, string> = {
  [TeamFilterOptionValues.HOME_TEAM]: TrackingFilters.HomeTeam,
  [TeamFilterOptionValues.AWAY_TEAM]: TrackingFilters.AwayTeam,
  [PlayerOnPitchStats.BOTH]: TrackingFilters.GoalAndAssist,
  [StatsShotsChartOptions.ON_OFF]: TrackingFilters.OnOffGame,
  [StatsShotsChartOptions.CONCEDED]: TrackingFilters.ConcededGame,
};
